class ComponentSection extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    const events = (this.getAttribute("event") || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    events.forEach((event_type) => {
      document.addEventListener(event_type, (event) => {
        this.render({ variant: event.detail.variant_id });
      });
    });
  }

  render(params = {}) {
    this.#controller?.abort();
    this.#controller = new AbortController();

    const url = new URL(location.pathname, location.origin);

    url.searchParams.set("section_id", this.id);

    for (const [param, value] of Object.entries(params)) {
      url.searchParams.set(param, value);
    }

    fetch(url.href, { signal: this.#controller.signal })
      .then(response => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.getElementById(this.id);

        this.innerHTML = fragment.innerHTML;
      })
      .catch((error) => {
        if (error.name == "AbortError") {
          return;
        }
      })
      .finally(() => {
        this.#controller = null;
      });
  }
}

customElements.define("component-section", ComponentSection);
